var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { Div } from "./Div";
/**
 *
 * @param props
 */
export var Container = function (props) {
    var clazzName = joinClasses(props.className || "", "scl-b-container");
    return !props.children
        ? null
        : (React.createElement(Div, __assign({}, props, { className: clazzName }), props.children));
};
